// @ts-check

import { getComponentWrapper } from './componentWrapper';
import { getHeadWrapper } from './headerWrapper';

/**
 * @typedef ContentPageExports
 * @property {ReturnType<getComponentWrapper>} default
 * @property {ReturnType<getHeadWrapper>} Head
 */

/**
 * @template {{}} [TProps={}] The shape of the props of the component.
 * @template {{}} [TData={}] The shape of the data passed into gatsby's data-field (graphql usually)
 * @function
 * @param {import('./componentWrapper').ComponentWrapperProps<TProps>} componentOptions
 * @param {import('./headerWrapper').HeadWrapperOptions<TData>} [headerOptions={}]
 * @returns {ContentPageExports}
 */
export function constructContentPage(componentOptions, headerOptions = {}) {
	const wrapped = getComponentWrapper(componentOptions);
	// @ts-ignore - this is just not true. Solved in TS.
	const headExport = getHeadWrapper(headerOptions);

	return {
		default: wrapped,
		Head: headExport,
	};
}
